export const iconFontAwesomeMedicalHealthPrescription = (
	<i className="fa-solid fa-prescription"></i>
);
